import { Reporter } from '../reporter/Reporter'

type props = { text?: string }

export const HappinessTrap: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'The Happiness Trap'}
      link="https://www.amazon.com/Happiness-Trap-Struggling-Living-Second-ebook/dp/B09XQBVS6B/"
    />
  </div>
)

export const FishOil: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Fish oil'}
      link="https://www.amazon.com/NOW-Ultra-Omega-Fish-Softgels/dp/B000SE5SY6"
    />
  </div>
)

export const Headspace: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Headspace'}
      link="https://www.headspace.com/"
    />
  </div>
)

export const Calm: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter text={text} defaultText={'Calm'} link="https://www.calm.com/" />
  </div>
)

export const Zencare: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Zencare'}
      link="https://www.zencare.co/"
    />
  </div>
)

export const BreatheIOS: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'iBreathe'}
      link="https://apps.apple.com/us/app/ibreathe-relax-and-breathe/id1296605806"
    />
  </div>
)

export const Breathe: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Breathe'}
      link="https://play.google.com/store/apps/details?id=uk.co.jatra.inout&hl=en_US&gl=US"
    />
  </div>
)
